(($) => {
    let $container;
    let $body;

    $(document).on('ready', init);
    
    function init() {
        $container = $('.to-top__container');
        $body = $('html, body');
        bind();
    }

    function bind() {
        $container.on('click', onContainerClick);
    }

    function onContainerClick(event) {
        document.dispatchEvent(new CustomEvent('gform-recaptcha:doAction', { detail: { action: 'to_top' }}));
        $body.animate({scrollTop: 0}, 'slow');
    }
})(jQuery);